<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex v-for="(item, index) of 4" :key="index + 10" xs12 md6 pa-3>
        <loader>
          <rect x="0" y="0" rx="3" ry="3" width="250" height="10" />
          <rect x="20" y="20" rx="3" ry="3" width="220" height="10" />
          <rect x="20" y="40" rx="3" ry="3" width="170" height="10" />
          <rect x="0" y="60" rx="3" ry="3" width="250" height="10" />
          <rect x="20" y="80" rx="3" ry="3" width="200" height="10" />
          <rect x="20" y="100" rx="3" ry="3" width="80" height="10" />
        </loader>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'

export default {
  name: 'Loader',
  components: {
    loader: ContentLoader,
  },
}
</script>
